import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "ab-account-cards",
  templateUrl: "./cards.component.html",
})
export class AccountCardsComponent implements OnChanges {
  @Input() public dur: string;
  @Input() public projects: any;
  @Input() public user: any;
  public newGroupCountList: number[];
  public newGroups: number;
  public unresolvedGroups: number;

  public ngOnChanges(changes: SimpleChanges) {
    if (!(changes.projects && changes.projects.currentValue)) {
      return;
    }

    const projects = changes.projects.currentValue;
    this.sumProjectStats(projects);
  }

  private sumProjectStats(projects: any) {
    this.unresolvedGroups = 0;
    this.newGroups = 0;
    this.newGroupCountList = [];

    for (const p of projects) {
      this.unresolvedGroups += p.unresolvedGroups;
      this.newGroups += p.newGroups;

      const countLists = ["newGroupCountList"];

      // Combines each of the project countLists into an account wide countList.
      // The countLists are used to calculate and display trends on each card.
      for (const countList of countLists) {
        for (let i = 0; i < p[countList].length; i++) {
          if ((this as any)[countList][i] === undefined) {
            (this as any)[countList][i] = p[countList][i];
          } else {
            (this as any)[countList][i] += p[countList][i];
          }
        }
      }
    }
  }
}
